import { render } from "./SecuritySet.vue?vue&type=template&id=19aaa0f5&scoped=true&ts=true"
import script from "./SecuritySet.vue?vue&type=script&lang=ts"
export * from "./SecuritySet.vue?vue&type=script&lang=ts"

import "./SecuritySet.vue?vue&type=style&index=0&id=19aaa0f5&lang=css"
import "./SecuritySet.vue?vue&type=style&index=1&id=19aaa0f5&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19aaa0f5"]])

export default __exports__